import axiosFetch from './config';


export const postProcessor = async (data) => {
  const token = await localStorage.getItem('token')
  return axiosFetch({
    method: 'POST',
    url: '/processor/quote',
    data,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}

export const postPayment = async (data, idempotencyKey) => {
  const token = await localStorage.getItem('token');

  return axiosFetch({
      method: 'POST',
      url: '/processor',
      data,
      headers: {
        Authorization: 'Bearer ' + token,
        idempotencyKey: idempotencyKey
      }
    });
}

export const getProductBalance = async (productId, accountNumber) => {

  const token = await localStorage.getItem('token');
  let url = `/processor/balance/products/${productId}/accountNumber/${accountNumber}`;

  let resp = await axiosFetch({
    method: 'GET',
    url: url,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })

  return resp.data;
}